import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import { safeBoolean } from '../../utils/utils'

export interface UhdBadgeProps {
  isUhd?: boolean
}

export const Uhd = ({ isUhd }: UhdBadgeProps) => (
  safeBoolean(isUhd) &&
  (<Badge use={badges.BORDERED_TEXT}>
    <span data-automation-id="uhd-badge">UHD</span>
  </Badge>) || null
)
